var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorAppointmentYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15721",
    "data-name": "Group 15721",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.253,
    height: 64.175,
    viewBox: "0 0 65.253 64.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16478",
    "data-name": "Rectangle 16478",
    width: 65.253,
    height: 64.175,
    fill: "#f5d730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15720",
    "data-name": "Group 15720",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41322",
    "data-name": "Path 41322",
    d: "M34.076,87.3c-.276.015-.444.032-.611.032q-13.953,0-27.907,0a5.2,5.2,0,0,1-5.343-3.85,5.844,5.844,0,0,1-.2-1.505Q0,64.233.007,46.489c0-.187.017-.374.029-.6H51.059V66.811A16.969,16.969,0,0,0,34.076,87.3M23.97,62.55q6.047,0,12.1,0a1.117,1.117,0,0,0,1.257-1.058,1.16,1.16,0,0,0-1.272-1.127c-.106,0-.212,0-.318,0H12.242c-.212,0-.469-.064-.626.032-.324.2-.729.431-.849.746a1.174,1.174,0,0,0,.222,1.029,1.645,1.645,0,0,0,1.078.365c3.968.025,7.936.015,11.9.015M19.061,70.62q-3.373,0-6.745,0a4.6,4.6,0,0,0-.7.035.99.99,0,0,0-.921.97,1.015,1.015,0,0,0,.795,1.142,2.207,2.207,0,0,0,.627.066q6.968,0,13.935,0a2.28,2.28,0,0,0,.746-.108,1.07,1.07,0,0,0-.172-2.054,4.686,4.686,0,0,0-.76-.047q-3.4,0-6.809,0",
    transform: "translate(-0.004 -34.175)",
    fill: "#f5d730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41323",
    "data-name": "Path 41323",
    d: "M140.74,151.19a14.664,14.664,0,1,1,14.618,14.666A14.632,14.632,0,0,1,140.74,151.19m12.591,3.97c-1.709-1.717-3.368-3.39-5.035-5.054a1.119,1.119,0,0,0-1.68-.151,1.089,1.089,0,0,0,.117,1.677q2.827,2.847,5.666,5.681a1.124,1.124,0,0,0,1.826.039q5.116-4.877,10.21-9.777a1.464,1.464,0,0,0,.4-.627,1,1,0,0,0-.468-1.208,1.069,1.069,0,0,0-1.387.219q-3.108,2.969-6.221,5.934l-3.429,3.267",
    transform: "translate(-104.814 -101.681)",
    fill: "#f5d730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41324",
    "data-name": "Path 41324",
    d: "M14.359.034H36.743c0,.77,0,1.524,0,2.278,0,.4-.02.809.018,1.209a1.1,1.1,0,0,0,2.193-.071c.034-.891.011-1.783.013-2.675,0-.228,0-.457,0-.723.273-.015.478-.037.684-.037C41.628.013,43.6.067,45.577,0a5.278,5.278,0,0,1,5.536,5.555c-.068,1.286-.011,2.579-.011,3.9H.054A2.516,2.516,0,0,1,0,9.058a43,43,0,0,1,.147-4.89A4.9,4.9,0,0,1,4.827.049C7.076-.023,9.329.021,11.58.015c.148,0,.3.013.554.026,0,.418,0,.832,0,1.246,0,.722-.022,1.445.012,2.166a1.1,1.1,0,1,0,2.2,0c.036-.891.013-1.784.015-2.675,0-.228,0-.456,0-.747",
    transform: "translate(0 0)",
    fill: "#f5d730"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorAppointmentYellow);
export default __webpack_public_path__ + "static/media/doctor-appointment-yellow.5cce6efe96fda4e4090be0833ea62844.svg";
export { ForwardRef as ReactComponent };